<div class="modal fade show" tabindex="-1" [class.d-block]="showModal" [style.background]="showModal ? 'rgba(0,0,0,0.5)' : ''" [style.display]="showModal ? 'block' : 'none'">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white">
        <h5 class="modal-title"><i class="bi bi-pencil-square me-2"></i>Actualizar Parámetro</h5>
        <button type="button" class="btn-close btn-close-white" (click)="closeModal()"></button>
      </div>
      <div class="modal-body">
        <div class="mb-2">
          <label class="form-label">Código:</label>
          <span class="fw-bold">{{ selectedParam?.code }}</span>
        </div>
        <div class="mb-2">
          <label class="form-label">Valor actual:</label>
          <span class="fw-bold">{{ selectedParam?.value }}</span>
        </div>
        <div class="mb-3">
          <label class="form-label">Nuevo valor</label>
          <input type="number" [ngModel]="newValue" (ngModelChange)="onValueChange($event)" class="form-control" placeholder="Nuevo valor">
        </div>
        <div *ngIf="errorMessage" class="alert alert-danger py-2">{{ errorMessage }}</div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="closeModal()">Cancelar</button>
        <button type="button" class="btn btn-primary" (click)="save()">Guardar</button>
      </div>
    </div>
  </div>
</div>
